const React = require("react");

const useId = require('@reach/auto-id').useId;

function ArrowRightOutlinedIcon(props, svgRef) {
  const id = "ArrowRightOutlinedIcon" + '_' + useId();
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.143 19.109a.54.54 0 00.01.743c.2.202.52.197.714-.012l6.99-7.5a.541.541 0 000-.732l-6.991-7.45a.49.49 0 00-.714-.008.54.54 0 00-.008.743l6.647 7.083-6.648 7.133z",
    id: `${id}_a`
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: `#${id}_a`
  }));
}

const ForwardRef = React.forwardRef(ArrowRightOutlinedIcon);
const MemoForwardRef = React.memo(ForwardRef);
module.exports = MemoForwardRef;